<template>
  <v-card flat outlined class="home-widget">
    <v-row class="pa-1">
      <v-col
        v-for="(office) in countryOffices"
        :key="office.id"
        class="d-flex justify-center clock-container"
      >
        <app-clock
          :timezone="office.timezone"
          :event="events && events[`${calendar.OFFICE_HOLIDAYS}_${office.id}`]
            ? events[`${calendar.OFFICE_HOLIDAYS}_${office.id}`][0].title
            : null"
        />
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import {mapGetters} from 'vuex';
import {calendar} from 'constants';
import _ from 'lodash';
export default {
  computed: {
    ...mapGetters(['offices']),
    countryOffices() {
      return _.uniqBy(this.offices.items, (office) => office.timezone);
    }
  },
  data() {
    return {
      calendar
    };
  },
  props: {
    events: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.clock-container {
  margin: auto;
}
</style>
